import MojitoCore from 'mojito/core';
import SportIconImpl from './sport-icon.js';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;

/**
 * `SportIcon` is a component used to render a sport icon.
 *
 * @class SportIcon
 * @memberof Mojito.Presentation.Components
 */

/**
 * `SportIcon` component prop types.
 *
 * @property {string} [sportId] - ID of the sport.
 * @property {string} [class] - Class name applied to the root image element.
 * @property {string} [alt] - The 'alt' attribute specifies an alternate text for an image, if the image cannot be displayed.
 *
 * @memberof Mojito.Presentation.Components.SportIcon
 */
const propTypes = {
    sportId: PropTypes.string,
    class: PropTypes.string,
    alt: PropTypes.string,
};

export default UIView('SportIcon', SportIconImpl, propTypes);
